module.exports = __webpack_public_path__ + "img/社交-合作.1049acc3.png";